// the generic `T` makes it so we avoid type widening. We  can pass a `string` type and it returns a `string` type or
// pass `string | undefined` type to get a `string | undefined` back
const getNineDigitNdc = <T extends string | undefined>(ndc: T): T => {
  return ndc?.substring(0, 9) as T
}

export default getNineDigitNdc
